import React, { useEffect, useState, useCallback, useRef } from 'react';
import CommonModal from './CommonModal';
import { callAPI } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';
import { toast } from 'react-toastify';
const EftposLinklyModal = ({ isOpen, onClose, uuid, amount, error, isPrepaid, onPaymentComplete = () => {} }) => {
  const [display, setDisplay] = useState({ DL1: '', DL2: '' });

  const [buttons, setButtons] = useState({
    AcceptYes: false,
    DeclineNo: false,
    Authorise: false,
    Cancel: false,
    CheckRetry: false,
    ManualCancel: false,
    ApprovedPinpad: false,
    ManualProcessed: false,
    Retry: false,
    OK: false,
    CustomOK: false,
    CustomCloseRetry: false,
  });

  const [spinning, setSpinning] = useState({});

  const uiLocked = useRef(false);

  useEffect(() => {
    const err = error?.error;
    if (!err) return;

    setDisplay({
      DL1: err.displayLine1 || '',
      DL2: err.displayLine2 || ''
    });

    setButtons({
      AcceptYes: false,
      DeclineNo: false,
      Authorise: false,
      Cancel: false,
      CheckRetry: err.actionBtn?.CheckStatusAndRetry || false,
      ManualCancel: err.actionBtn?.CustomCancel || false,
      ApprovedPinpad: err.actionBtn?.ApprovedOnPinpad || false,
      ManualProcessed: err.actionBtn?.ManuallyProcessedOnPinpad || false,
      Retry: false,
      OK: false,
      CustomOK: err.actionBtn?.custOk || false,
      CustomCloseRetry: err.actionBtn?.CustomOkPOP || false,
    });

  }, [error]);


  const fetchStatus = useCallback(async () => {
    try {
      console.log()
      const res = await callAPI(
        `${apiUrls.LINKLY_STATUS}?uuid=${uuid}&isPrepaid=${isPrepaid ? 1 : 0}`,
        {},
        'GET',
        null, {},  {}, false
      );
      const data = res?.data || {};
      const eft = data.eftpos_display || {};
      const btn = eft.actionBtn || {};

      setDisplay({
        DL1: eft.displayLine1 || '',
        DL2: eft.displayLine2 || '',
      });


      if (!uiLocked.current) {
        setButtons({
          AcceptYes: btn.AcceptYesKeyFlag || false,
          DeclineNo: btn.DeclineNoKeyFlag || false,
          Authorise: btn.AuthoriseKeyFlag || false,
          Cancel: btn.CancelKeyFlag || false,
          CheckRetry: btn.CheckStatusAndRetry || false,
          ManualCancel: btn.CustomCancel || false,
          ApprovedPinpad: btn.ApprovedOnPinpad || false,
          ManualProcessed: btn.ManuallyProcessedOnPinpad || false,
          Retry: btn.retry || false,
          OK: btn.OKKeyFlag || false,
          CustomOK: btn.custOk || false,
          CustomCloseRetry: btn.CustomOkPOP || false,
        });
      }

      const status = data.linkly_payment?.status;

      if (status == 1 || status == 'success') {
        uiLocked.current = true;

        setButtons(prev => ({
          ...prev,
          CustomCloseRetry: false
        }));

        //        setTimeout(onClose, 1000);

        setTimeout(() => {
          onPaymentComplete();
        }, 1000);
      }

      if (status == 2) {
         
        uiLocked.current = true;
        setButtons(prev => ({
          ...prev,
          ManualProcessed: true,
          //ManualCancel:true

        }));

        setDisplay({
          DL1: eft.displayLine1 || '',
          DL2: eft.displayLine2 || '',
        });
      
        return;
      }

    } catch (err) {
      console.error(err);

      setDisplay({

        DL1: 'Processing. Please Wait...',
        DL2: 'Please do not hit back button or refresh window',
      });

      setButtons(prev => ({
        ...prev,
        ManualCancel: true,
        Retry: true,
      }));
    }
  }, [uuid, onClose]);

  useEffect(() => {
    if (!uuid || !isOpen) return;

    uiLocked.current = false;

    fetchStatus();
    const intervalId = setInterval(fetchStatus, 1000);

    return () => clearInterval(intervalId);
  }, [uuid, isOpen, fetchStatus]);


  const handleSendKey = async (key) => {
    if (!uuid || !buttons[key]) return;

    setSpinning(prev => ({ ...prev, [key]: true }));

    try {
      let payload = { uuid };

      if (key === 'AcceptYes') payload.key = 1;
      else if (key === 'DeclineNo') payload.key = 2;
      else if (key === 'Cancel') payload.key = 0;

      await callAPI(apiUrls.LINKLY_SEND_KEY, {}, 'POST', payload);

      await fetchStatus();

    } catch (err) {
      toast.error('Action failed');
    } finally {
      setSpinning(prev => ({ ...prev, [key]: false }));
    }
  };

  // const handleManual = async (type) => {
  //   try {
  //     uiLocked.current = true;

  //     await callAPI(apiUrls.LINKLY_STATUS_MANUAL, {}, 'POST', {
  //       uuid,
  //       button_name: type
  //     });


  //     await fetchStatus();

  //   } catch (err) {
  //     toast.error('Action failed');
  //   }
  // };



  const handleManual = async (type) => {
    try {
      const res = await callAPI(
        apiUrls.LINKLY_STATUS_MANUAL,
        {},
        'POST',
        {
          uuid,
          button_name: type,
          isPrepaid: isPrepaid ? 1 : 0
        }
      );
  
      const data = res?.data || {};
  
      if (data.status == 1) {
        toast.success(data.message || 'Success');
  
        
        if (type === 'manuallyProcessed') {
          setTimeout(() => {
            onPaymentComplete();
          }, 1000);
          return;
        }
  
        
        if (type === 'manuallycancel') {
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          return;
        }
  
        
        if (type === 'manuallyok') {
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          return;
        }
  
        return;
      }
  
      
      toast.error(
        (data.message || 'Action failed') +
        '. Please manually go back and try again.'
      );
  
      setButtons(prev => ({
        ...prev,
        CustomCloseRetry: true,
      }));
  
    } catch (err) {
      console.error(err);
  
      toast.error(
        'Action failed. Please manually go back and try again.'
      );
  
      setButtons(prev => ({
        ...prev,
        CustomCloseRetry: true,
      }));
    }
  };

  const handleRetry = async () => {
    try {
      await callAPI(apiUrls.LINKLY_RETRY, {}, 'POST', { uuid });
      await fetchStatus();
    } catch (err) {
      toast.error('Retry failed');
    }
  };

  const isLoading = !display.DL1 && !display.DL2;

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} elId="eftposModal"  closeOnBackdropClick={false}  closeOnEscape={false}>

      <div className="modal-body p-5 text-center">

        {amount && (
          <h2 style={{ color: '#1aa260' }}>
            Purchase ${amount}
          </h2>
        )}

        {isLoading && <h5>Processing...</h5>}

        <div className="mt-3">
          <h4>{display.DL1}</h4>
          <span dangerouslySetInnerHTML={{ __html: display.DL2 }} />
        </div>

        <div className="mt-4 d-flex flex-wrap justify-content-center gap-2">

          {buttons.AcceptYes && (
            <button className="btn btn-primary"
              onClick={() => handleSendKey('AcceptYes')}>
              Accept
            </button>
          )}

          {buttons.DeclineNo && (
            <button className="btn btn-primary"
              onClick={() => handleSendKey('DeclineNo')}>
              Decline
            </button>
          )}

          {buttons.Cancel && (
            <button className="btn btn-primary"
              onClick={() => handleSendKey('Cancel')}>
              Cancel
            </button>
          )}

          {buttons.CheckRetry && (
            <button className="btn btn-secondary"
              onClick={handleRetry}>
              Check & Retry
            </button>
          )}

          {buttons.ManualCancel && (
            <button className="btn btn-primary"
              onClick={() => handleManual('manuallycancel')}>
              Cancel
            </button>
          )}

          {buttons.ManualProcessed && (
            <button className="btn btn-secondary"
              onClick={() => handleManual('manuallyProcessed')}>
              Manual Processed
            </button>
          )}

          {buttons.CustomOK && (
            <button className="btn btn-secondary"
              onClick={() => handleManual('manuallyok')}>
              OK
            </button>
          )}


          {buttons.CustomCloseRetry && (
            <button className="btn btn-danger"
              onClick={() => window.location.reload()}>
              Close & Retry
            </button>
          )}

        </div>
      </div>
    </CommonModal>
  );
};

export default EftposLinklyModal;